import moment from 'moment-timezone';
import React from 'react';

import { ScheduledCallStatus } from '../constants';
import { Filter } from './items';

export const getCallStatus = (scheduledCall, timeZone) => {
  // Read status from _fields for athenaAppointment, otherwise from the object directly
  const status = scheduledCall?.isAthenaAppointment
    ? scheduledCall?._fields?.status
    : scheduledCall?.status;

  if (!status) return '-';
  if (![ScheduledCallStatus.SCHEDULED, ScheduledCallStatus.RESCHEDULED].includes(status)) {
    return status;
  }

  const today = moment.tz(timeZone);
  // Read scheduledAt from _fields for athenaAppointment, otherwise from the object directly
  const scheduledAt = scheduledCall?.isAthenaAppointment
    ? scheduledCall?._fields?.scheduledAt
    : scheduledCall?.scheduledAt;
  const scheduledDate = moment.tz(scheduledAt, timeZone);
  const isScheduledForToday = today.isSame(scheduledDate, 'day');

  return isScheduledForToday ? 'today' : status;
};

export const getHeaders = (types, setTypes, patientId) => {
  const headers = [
    { column: 'scheduledTime', label: 'Scheduled Time', width: '14%', sortBy: 'date' },
    { column: 'createdTime', label: 'Created Time', width: '10%', sortBy: 'date' },
  ];

  if (!patientId) {
    headers.push({ column: 'patientId', label: 'MRN', width: '10%' });
  }

  headers.push({
    column: 'type',
    label: 'Type',
    filter: <Filter types={types} setTypes={setTypes} />,
    width: '16%',
  });

  if (patientId) {
    headers.push({ column: 'reason', label: 'Visit Reason', width: '11%' });
  }

  headers.push(
    { column: 'assigned', label: 'Assigned', width: '10%' },
    { column: 'status', label: 'Status', width: '10%' },
    { column: 'actions', label: 'Actions', width: '29%' },
  );

  return headers;
};
